import React from 'react'
import HomeMap from 'components/Home/HomeMap'

export default function Map1({data}) {
    const {mapButtonText, mapCountries, mapStates, mapStudents, mapSubtitle, mapTeachers, mapTitle, mapButtonLink, mapExternalLink} = data
    return (
        <HomeMap
            mapButtonLink={mapButtonLink}
            mapExternalLink={mapExternalLink}
            mapButtonText={mapButtonText}
            mapsSubtitle={mapSubtitle}
            mapsTitle={mapTitle}
            countries={mapCountries}
            states={mapStates}
            students={mapStudents}
            teachers={mapTeachers}
        />
    )
}
